export default {
    buttons: {
        save: 'Сохранить',
    },
    fields: {
        phone: {
            label: 'Номер телефона',
            placeholder: '+3811231231',
        },
    },
    errors: {
        user_resend_limit_reached_contact_support: 'Достигнут лимит повторных отправок. Обратитесь в службу поддержки!',
        user_resend_limit_reached: 'Достигнут лимит повторных отправок. Попробуйте снова через 15 минут!',
        user_mobile_already_verified: 'Этот номер телефона уже подтвержден',
        user_resend_spam_detected: 'Достигнут лимит повторных отправок. Обратитесь в службу поддержки!',
    },
}
